import React, { lazy } from 'react'

const BeneficiaryBankCodeListing = lazy(() =>
  import('./BeneficiaryBankCodeListing').then(module => ({
    default: module.BeneficiaryBankCodeListing,
  }))
)

const BeneficiaryBankCodeDetail = lazy(() =>
  import('./BeneficiaryBankCodeDetail').then(module => ({
    default: module.BeneficiaryBankCodeDetail,
  }))
)

export const BeneficiaryBankCodeRoutes = [
  {
    props: {
      exact: true,
      path: `/common-setting/beneficiary-bank-code`,
    },
    component: <BeneficiaryBankCodeListing />,
  },
  {
    props: {
      exact: true,
      path: `/common-setting/beneficiary-bank-code/:BankCodeID`,
    },
    component: <BeneficiaryBankCodeDetail />,
  },
]

export default BeneficiaryBankCodeRoutes
